import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { NAV_ITEMS } from "@/app/navigation";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.07 } },
};
const card = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0 },
};

export default function Home() {
  const pillars = NAV_ITEMS.filter((i) => i.pillar);
  const others = NAV_ITEMS.filter((i) => !i.pillar && i.path !== "/settings");

  return (
    <div className="space-y-10">
      {/* Hero */}
      <div className="rounded-3xl border border-border bg-gradient-to-br from-surface to-surface-2 p-8 sm:p-10 shadow-glow">
        <p className="text-sm font-medium text-accent">Game Design Studio</p>
        <h2 className="mt-2 font-display text-3xl sm:text-4xl font-bold text-text">
          Sharpen your design skills, one challenge at a time.
        </h2>
        <p className="mt-3 max-w-2xl text-muted">
          Pick a mode below. Hippo serves a randomized real-world challenge,
          tracks your progress, and builds your personal library of game-design
          knowledge.
        </p>
      </div>

      {/* Pillars */}
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
      >
        {pillars.map((item) => (
          <motion.div key={item.path} variants={card}>
            <Link
              to={item.path}
              className="group flex h-full flex-col rounded-2xl border border-border bg-surface p-6 transition-all hover:-translate-y-1 hover:border-primary/50 hover:shadow-glow"
            >
              <div className="grid h-12 w-12 place-items-center rounded-xl bg-surface-2 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-fg">
                <item.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold text-text">
                {item.label}
              </h3>
              <p className="mt-1 flex-1 text-sm text-muted">{item.blurb}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary">
                Open
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          </motion.div>
        ))}
      </motion.div>

      {/* Secondary destinations */}
      <div>
        <h3 className="mb-4 font-display text-sm font-semibold uppercase tracking-wide text-muted">
          Also in Hippo
        </h3>
        <div className="grid gap-4 sm:grid-cols-2">
          {others.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="group flex items-center gap-4 rounded-xl border border-border bg-surface p-4 transition-colors hover:bg-surface-2"
            >
              <div className="grid h-10 w-10 place-items-center rounded-lg bg-surface-2 text-accent">
                <item.icon className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <div className="font-medium text-text">{item.label}</div>
                <div className="truncate text-sm text-muted">{item.blurb}</div>
              </div>
              <ArrowRight className="ml-auto h-4 w-4 text-muted transition-transform group-hover:translate-x-1" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
